import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import GoodsInWarehouse from './goods-warehouse/goods-in-warehouse';
import { PageLink, PageTitle } from '../../../umart_admin/layout/core';
import AddGoodsInWarehouse from './goods-warehouse/add-goods-inventory';
import AllLowStocks from './low-stock-list/all-low-stocks';
const inventoryBreadCrumbs: Array<PageLink> = [
  {
    title: 'Inventory',
    path: '#',
    isSeparator: false,
    isActive: false,
  },
];
const InventoryPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route
        index
        element={<Navigate to="/inventory/goods-in-warehouse" />}
      />
      <Route
        path="goods-in-warehouse"
        element={
          <>
            <PageTitle
              showHeading
              breadcrumbs={inventoryBreadCrumbs}
            >
              Goods In Warehouse
            </PageTitle>
            <GoodsInWarehouse />
          </>
        }
      />
      <Route
        path="add-goods-in-inventory"
        element={
          <>
            <PageTitle breadcrumbs={inventoryBreadCrumbs}>
              Add Goods In Warehouse
            </PageTitle>
            <AddGoodsInWarehouse />
          </>
        }
      />
      <Route
        path="low-stock-list"
        element={
          <>
            <PageTitle breadcrumbs={inventoryBreadCrumbs}>
             Low Stock List
            </PageTitle>
            <AllLowStocks />
          </>
        }
      />
    </Route>
  </Routes>
);
export default InventoryPage;
